import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

export const WHATSAPP_NUMBER = "917054112345"; // OC Infraventures WhatsApp (India, country code 91)

export const buildWhatsAppLink = (msg) => {
  const text = encodeURIComponent(msg || "Hi OC Infraventures, I'd like to know more about your real estate services.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 800);
    return () => clearTimeout(t);
  }, []);

  if (!mounted) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[60]" data-testid="whatsapp-fab-container">
      {open && (
        <div
          data-testid="whatsapp-fab-card"
          className="mb-3 w-72 bg-slate-900 border border-white/10 shadow-2xl overflow-hidden"
          style={{ animation: "fadeUp 220ms ease both" }}
        >
          <div className="bg-emerald-600 px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2 text-white">
              <MessageCircle className="w-4 h-4" strokeWidth={2} />
              <div className="font-medium text-sm">OC Infraventures</div>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="whatsapp-fab-close"
              className="text-white/80 hover:text-white"
              aria-label="Close"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="p-4">
            <p className="text-sm text-slate-300 leading-relaxed">
              Hi <span className="text-amber-500">there</span> — our consultants are online.
              Tell us what you're looking for and we'll respond within 5 minutes.
            </p>
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-fab-start-chat"
              className="mt-4 w-full bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-medium py-2.5 transition-colors flex items-center justify-center gap-2"
            >
              <MessageCircle className="w-4 h-4" /> Start chat
            </a>
            <div className="text-[10px] text-slate-500 mt-3 text-center">
              Mon–Sat · 10:00–19:00 IST
            </div>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-fab-toggle"
        aria-label="WhatsApp chat"
        className="w-14 h-14 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white flex items-center justify-center shadow-2xl transition-transform hover:scale-105 ring-4 ring-emerald-600/20"
      >
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" strokeWidth={2} />}
      </button>
    </div>
  );
}
